export class Person {
  name: string;
  lastname: string;
  dni: number;
}
